<div class=" d-flex justify-content-center align-items-center" style="height: 100% !important;">
  <app-formulario class="overflow: hidden; " style="width: 100% ;"></app-formulario>
</div>
